// @Utility
import alertText from "@utility/app/alertText";

// Services
import { apiServices } from "@core/services/appService";

// Redux
import { setStatusSpinner } from "@core/redux/actions/app/spinner";
import { setDataAlert } from "@core/redux/actions/app/alert";
import { loadHomeData } from "@core/redux/actions/home/index";

const SET_CAMPAIGN_LIST_DATA = "app/home/SET_CAMPAIGN_LIST_DATA";

function loadCampaignListData() {
    return dispatch => {
        const agentCode = process.env?.REACT_APP_DEFAULT_AGENT_CODE

        apiServices({}, "get", `/general/campaign/${agentCode}`).then((data) => {
            const { code: statusCode, result } = data;

            if (statusCode === 200 || statusCode === 0) {
                dispatch({
                    type: SET_CAMPAIGN_LIST_DATA,
                    payload: {
                        items: result
                    }
                })
            }
            else {
                dispatch({
                    type: SET_CAMPAIGN_LIST_DATA,
                    payload: {
                        items: null
                    }
                })
            }
        });
    }
}

function confirmJoinCampaign(dataJson, reloadData) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: "ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่..." }));

        apiServices(dataJson, "post", "/customer/campaign/select").then((data) => {
            const { code: statusCode } = data;

            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch(loadHomeData());

                if (reloadData) {
                    reloadData();
                }

                dispatch(setDataAlert({
                    type: "success",
                    title: "แจ้งเตือน",
                    text: "เข้าร่วมแคมเปญสำเร็จ !",
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
            else {
                let snackbarJson = alertText(statusCode);
                dispatch(setDataAlert({
                    type: snackbarJson.statusAlert,
                    title: snackbarJson.titleAlert,
                    text: snackbarJson.textAlert,
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
        });
    }
};

function claimRewardCampaign(dataJson, reloadData, rewardType, gotoPage) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: "ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่..." }));

        apiServices(dataJson, "post", "/customer/campaign/claim").then((data) => {
            const { code: statusCode } = data;

            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch(loadHomeData());

                if (reloadData) {
                    reloadData();
                }

                if (rewardType === 2 && gotoPage) {
                    gotoPage("/game/campaign")
                }

                dispatch(setDataAlert({
                    type: "success",
                    title: "แจ้งเตือน",
                    text: "รับรางวัลสำเร็จ !",
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
            else {
                let snackbarJson = alertText(statusCode);
                dispatch(setDataAlert({
                    type: snackbarJson.statusAlert,
                    title: snackbarJson.titleAlert,
                    text: snackbarJson.textAlert,
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
        });
    }
};

function setSelectCampaign(data) {
    return {
        type: SET_CAMPAIGN_LIST_DATA,
        payload: { items: data }
    };
}

export {
    SET_CAMPAIGN_LIST_DATA,
    loadCampaignListData,
    confirmJoinCampaign,
    claimRewardCampaign,
    setSelectCampaign
}